import { OptionType } from '@components/Select';
import { Declension } from '@utils/Declension';

export const DISABLE_ITEM_PRESENTATION_FROM: Date = new Date('2025-07-22T00:00:00.000Z');
export const ENTRY_CONTENT_IN_VIEW_MODE_IDENTIFIER = 'entryContentInViewMode';
export const ENTRY_EDS_STAMP_IN_VIEW_MODE_IDENTIFIER = 'entryEdsStampInViewMode';
export const MEDICAL_CASE_RELEASE_DATE = new Date('2022-05-04');

// Functions need for correct lang
export function getReferralDurationOptions(): OptionType<number>[] {
    return [
        {
            value: 15,
            label: `15 ${Declension.days(15)}`,
        },
        {
            value: 30,
            label: `30 ${Declension.days(30)}`,
        },
        {
            value: 60,
            label: `60 ${Declension.days(60)}`,
        },
        {
            value: 90,
            label: `90 ${Declension.days(90)}`,
        },
        {
            value: 365,
            label: `365 ${Declension.days(365)}`,
        },
    ];
}

export function getDrugDurationOptions(): OptionType<number>[] {
    return [
        {
            value: 3,
            label: `3 ${Declension.days(3)}`,
        },
        {
            value: 7,
            label: `7 ${Declension.days(7)}`,
        },
        {
            value: 10,
            label: `10 ${Declension.days(10)}`,
        },
        {
            value: 30,
            label: `30 ${Declension.days(30)}`,
        },
        {
            value: 90,
            label: `90 ${Declension.days(90)}`,
        },
    ];
}

export function getTaskDurationOptions(): OptionType<number>[] {
    return [
        {
            value: 1,
            label: `1 ${Declension.days(1)}`,
        },
        {
            value: 7,
            label: `7 ${Declension.days(7)}`,
        },
        {
            value: 14,
            label: `14 ${Declension.days(14)}`,
        },
    ];
}
